module.exports = __webpack_public_path__ + "static/media/moons_dudas_cita-960.9925b6f2.webp";